export var ResultFeedbackType;
(function (ResultFeedbackType) {
    ResultFeedbackType["SUCCESS"] = "SUCCESS";
    ResultFeedbackType["ERROR"] = "ERROR";
    ResultFeedbackType["PENDING"] = "PENDING";
    ResultFeedbackType["WARNING"] = "WARNING";
})(ResultFeedbackType || (ResultFeedbackType = {}));
//# sourceMappingURL=resultFeedback.js.map